import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import DefaultLayout from "/home/runner/work/documentation/documentation/node_modules/gatsby-theme-doctornpm/src/components/layout.js";
import shared from '../../../src/shared.js';
export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const Note = makeShortcode("Note");
const Screenshot = makeShortcode("Screenshot");
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">



    <Note mdxType="Note">
      <p><strong parentName="p">{`Note:`}</strong>{` This article only applies to users of the public npm registry.`}</p>
    </Note>
    <p>{`If you need to install and publish private packages, you can upgrade to a paid user account plan. Our paid user account plan costs $7 per month. For more information, see the "npm account" column on our `}<a parentName="p" {...{
        "href": "https://www.npmjs.com/pricing"
      }}>{`pricing page`}</a>{`.`}</p>
    <p>{`Your paid plan and billing cycle will start when you submit your credit card information, and you will be charged for the first month immediately.`}</p>
    <ol>
      <li parentName="ol">
        <>{shared['user-login'].text}</>
        <>{shared['user-login'].image}</>
      </li>
      <li parentName="ol">
        <>{shared['billing-info'].text}</>
        <>{shared['billing-info'].image}</>
      </li>
      <li parentName="ol">
        <p parentName="li">{`Under "change plan", click `}<strong parentName="p">{`Upgrade Plan ($7/User)`}</strong>{`.`}</p>
        <Screenshot src="/getting-started/paying-for-your-npm-user-account/change-plan.png" alt="Screenshot of the change payment plan button" mdxType="Screenshot" />
      </li>
      <li parentName="ol">
        <p parentName="li">{`Under "Want to upgrade?", click `}<strong parentName="p">{`Enable Private Publishing for $7/mo`}</strong>{`.`}</p>
        <Screenshot src="/getting-started/paying-for-your-npm-user-account/enable-private-publishing.png" alt="Screenshot showing the enable private publishing button" mdxType="Screenshot" />
      </li>
      <li parentName="ol">
        <>{shared['billing-form'].text}</>
        <>{shared['billing-form'].image}</>
      </li>
      <li parentName="ol">
        <>{shared['payment-info-button'].text}</>
        <>{shared['payment-info-button'].image}</>
      </li>
      <li parentName="ol">
        <>{shared['billing-creditcard-form'].text}</>
        <Screenshot src="/getting-started/paying-for-your-npm-user-account/billing-upgrade-form.png" alt="Screenshot of the payment form" mdxType="Screenshot" />
      </li>
      <li parentName="ol">
        <>{shared['payment-remember-me'].text}</>
        <>{shared['payment-remember-me'].image}</>
      </li>
      <li parentName="ol">
        <p parentName="li">{`Click `}<strong parentName="p">{`Pay $7.00`}</strong>{`.`}</p>
        <Screenshot src="/getting-started/paying-for-your-npm-user-account/billing-upgrade-button.png" alt="Screenshot of the payment confirmation button" mdxType="Screenshot" />
      </li>
    </ol>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      